var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "2 2 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24991 3C4.00791 3 2.99991 4.008 2.99991 5.25C2.99991 6.492 4.00791 7.5 5.24991 7.5C6.49191 7.5 7.49991 6.492 7.49991 5.25C7.49991 4.008 6.49191 3 5.24991 3ZM9.29931 14.2144C9.29931 11.0044 11.9193 8.4004 15.1503 8.4004C18.3803 8.4004 21.0003 11.0044 21.0003 14.2144V20.0994C21.0003 20.5964 20.5963 21.0004 20.0993 21.0004H18.0003C17.5033 21.0004 17.0993 20.5964 17.0993 20.0994V14.3344C17.0993 13.3154 16.3663 12.3884 15.3523 12.2874C14.1843 12.1704 13.2003 13.0784 13.2003 14.2144V20.0994C13.2003 20.5964 12.7963 21.0004 12.2993 21.0004H10.2003C9.70331 21.0004 9.29931 20.5964 9.29931 20.0994V14.2144ZM2.99951 10.1998C2.99951 9.7028 3.40351 9.2998 3.90051 9.2998H6.59951C7.09651 9.2998 7.49951 9.7028 7.49951 10.1998V20.0998C7.49951 20.5968 7.09651 20.9998 6.59951 20.9998H3.90051C3.40351 20.9998 2.99951 20.5968 2.99951 20.0998V10.1998Z",
    fill: "#45655E",
    strokeWidth: 1.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a91df5ee.svg";
export { ForwardRef as ReactComponent };